module.exports = __webpack_public_path__ + "img/98cf3b3.jpg";